import React from 'react'
import styled from '@emotion/styled'
import { Button, Col, Row } from 'antd'

interface ActionsProps {
  discardHandler: () => void
  saveHandler: () => void
  loading: boolean
}

const Actions = ({ discardHandler, saveHandler, loading }: ActionsProps) => {
  return (
    <LocationInventoryPricingsActions className='_mb-0'>
      <Col span={12}></Col>
      <Col span={12}>
        <Row className='_mb-0' justify='end' gutter={[8, 8]}>
          <Col>
            <Button ghost type='primary' onClick={() => discardHandler()}>
              Discard
            </Button>
          </Col>
          <Col>
            <Button type='primary' onClick={saveHandler} loading={loading}>
              Save
            </Button>
          </Col>
        </Row>
      </Col>
    </LocationInventoryPricingsActions>
  )
}

const LocationInventoryPricingsActions = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #4a4a68;
  padding: 8px 16px;
`

export default Actions
